import * as GlobalConstants from "../constants/GlobalConstants";
import * as SavedReportConstants from "../constants/SavedReportConstants";

// Report screen id <-> API ReportLevel.
const LEVEL_BY_REPORT = {
  [GlobalConstants.LEARNING_PROGRAM_REPORTS]:
    SavedReportConstants.REPORT_LEVEL_PROGRAMS,
  [GlobalConstants.LEARNING_MILESTONE_REPORTS]:
    SavedReportConstants.REPORT_LEVEL_MILESTONES,
  [GlobalConstants.LEARNING_OBJECT_REPORTS]:
    SavedReportConstants.REPORT_LEVEL_OBJECTS,
};

// The report "type" query values. The API stores and returns the saved
// training type as the same words (the only enum it does not send as a number).
const TRAINING_TYPES = [
  GlobalConstants.TRAINING_TYPE_REQUIRED,
  GlobalConstants.TRAINING_TYPE_OPTIONAL,
  GlobalConstants.TRAINING_TYPE_ALL,
];

const trainingTypeOf = (type) =>
  TRAINING_TYPES.includes(type) ? type : GlobalConstants.TRAINING_TYPE_REQUIRED;

// Same rule the report screens use when they send user filters.
const BUILT_IN_USER_FILTERS = ["Designation", "Department", "ManagerId"];

const DEFAULT_SORT_COLUMN = "firstName";
const DEFAULT_SORT_BY = "asc";

const keyOf = (map, value) =>
  Object.keys(map).find((key) => map[key] === value);

export const toReportLevel = (reportId) =>
  LEVEL_BY_REPORT[reportId] || SavedReportConstants.REPORT_LEVEL_PROGRAMS;

export const fromReportLevel = (level) =>
  keyOf(LEVEL_BY_REPORT, level) || GlobalConstants.LEARNING_PROGRAM_REPORTS;

const toStatuses = (status) => {
  if (Array.isArray(status)) {
    return [...status];
  }
  return status ? [status] : [];
};

// reportState: { namePattern, objectNamePattern, status (array on Reports,
// single value on My team), type ("required" | "optional" | "all"),
// sortColumn, sortBy, userFilters (the UserFilters state) }.
export const toSavedFilters = ({
  namePattern,
  objectNamePattern,
  status,
  type,
  sortColumn,
  sortBy,
  userFilters = [],
} = {}) => ({
  namePattern: namePattern || null,
  objectNamePattern: objectNamePattern || null,
  statuses: toStatuses(status),
  type: trainingTypeOf(type),
  sortColumn: sortColumn || null,
  sortBy: sortBy || null,
  userFilters: (userFilters || [])
    .filter((item) => item.values?.length > 0)
    .map((item) => ({
      id: item.id,
      isDynamicField: !BUILT_IN_USER_FILTERS.includes(item.id),
      values: [...item.values],
    })),
});

// User filters come back with only their id and values; UserFilters fills in
// the name and options from the tenant's fields when it renders them.
export const fromSavedFilters = (filters) => ({
  namePattern: filters?.namePattern || "",
  objectNamePattern: filters?.objectNamePattern || "",
  statuses: [...(filters?.statuses || [])],
  type: trainingTypeOf(filters?.type),
  sortColumn: filters?.sortColumn || DEFAULT_SORT_COLUMN,
  sortBy: filters?.sortBy || DEFAULT_SORT_BY,
  userFilters: (filters?.userFilters || []).map((item) => ({
    id: item.id,
    name: item.id,
    options: [],
    values: [...(item.values || [])],
  })),
});
